import React, { Component } from "react";
import { Button, Form, Icon, Grid, Card, Table } from "tabler-react";
import PerfilesTabs from "../../components/TabsLayout.react";
import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
import Select from 'react-select';
import AdminstracionView from "./views/AdminstracionView.react";
import MonitoreoPageView from "./views/MonitoreoPageView.react";
import NavieroView from "./views/NavieroView";
import UsuarioConsolaView from "./views/UsuarioConsolaView";
import AsignarGpsView from "./views/AsignarGpsView";
import RecuperarGpsView from "./views/RecuperarGpsView";
import DashboardView from "./views/DashboardView";
var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
class Bloques extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      Funcionalidades: [],
      search: "",
      bloque: { value: 0, label: "Seleccione una opción" },
      funcionalidades: [],
      updatePanel: false
    };
    this.Funcionalidades = [];
    this.perfilesObject = [];
    this.checarFuncionalidades= 0;      //temporal render
    this.idPerfilesFuncionalidades = 0; //temporal render
    this.perfilesFuncionalidadesObject = [];
    this.FuncionalidadesArray = [];

    this.bloques=  [];   
  }
  componentWillMount=()=>{
    this.bloques.push({ value: 0, label: "Seleccione una opción" });
    this.props.stor.bloques_object.map((bloq, index)=>{      
      if(bloq.nombre !== "navieraMovimientos" && bloq.nombre !== "terrestreMovimientos"){
        this.bloques.push({ value: bloq.id, label: bloq.nombre });
      }
    });
  }

  componentDidMount = () => {
    if (this.state.accion !== 'nuevo') {
      this.setState({ id: this.props.elementos.id });
      this.perfilesObject = this.props.elementos;

     this.getfuntion("get", "", "", "perfilesFuncionalidades/"+ this.props.elementos.id, "Funcionalidades");
    } else { }
  }

  getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
      /**
       * filtro de variables
       */
      //console.log("returnVal");
      //console.log(returnVal);
      switch (metodo) {
        case "get":
          {
            if (stateVar === "Funcionalidades") {
              this.Funcionalidades = returnVal;
              this.setState({ Funcionalidades: returnVal });
            }
          }
          break;
        case "post":
          {
            if (stateVar === "Funcionalidades") {
              this.Funcionalidades.push(returnVal);
              this.setState({ Funcionalidades: this.Funcionalidades });
              let funcionalidades=[];
              this.props.stor.funcionalidades_object.filter(word => word.bloque.nombre.includes( this.state.bloque.label )).sort().map((elemento, index) =>{
                this.Funcionalidades.map((elemFuncionalidad, ind) => {
                  if (elemFuncionalidad.idFuncionalidad === elemento.id) {
                    funcionalidades.push(elemento);
                  }
                });
              });              
              this.setState({ funcionalidades: funcionalidades });
              this.setState({updatePanel: false});             
            }
          }
          break;
        case "delete":
          {
            if (stateVar === "Funcionalidades") {
              this.Funcionalidades.map((elemento, index) => {
                if (id === elemento.id) {
                  this.Funcionalidades.splice(index, 1);
                  let funcionalidades=[];
                  this.props.stor.funcionalidades_object.filter(word => word.bloque.nombre.includes( this.state.bloque.label )).sort().map((elemento, index) =>{
                    this.Funcionalidades.map((elemFuncionalidad, ind) => {
                      if (elemFuncionalidad.idFuncionalidad === elemento.id) {
                        funcionalidades.push(elemento);
                      }
                    });
                  });                  
                  this.setState({ funcionalidades: funcionalidades });
                }
              }
              )
              this.setState({ Funcionalidades: this.Funcionalidades });
              this.setState({updatePanel: false});
            }
          }
          break;
        default:
          break;
      }
    }).catch(err => {
      if (err.response) {
        console.log(err.response);
      } else {
        /**
         * Error
         */
        console.log("Error desconocido ...."+ err);
        //console.log(err)
      }
    })
  }


  changeFuncionalidades = (FuncionalidadIndex, OtdId, OtdStatus) => {
    this.perfilesFuncionalidadesObject = {
      "idPerfil": this.perfilesObject.id,
      "idFuncionalidad": this.props.stor.funcionalidades_object.filter(word => word.bloque.nombre.includes( this.state.bloque.label ) &&   
      word.nombre.toUpperCase().includes(this.state.search.toUpperCase())).sort()[FuncionalidadIndex].id
    }
    this.setState({updatePanel: true});
    this.FuncionalidadesArray[FuncionalidadIndex].estatus === 1 ?
      this.getfuntion("delete", "", this.FuncionalidadesArray[FuncionalidadIndex].id, "perfilesFuncionalidades", "Funcionalidades")
      :
      this.getfuntion("post", this.perfilesFuncionalidadesObject, "", "perfilesFuncionalidades", "Funcionalidades");
  }
  checkedFuncionalidades = (indice) => {
    //console.log("INdice "+this.FuncionalidadesArray[indice].estatus);

    return this.FuncionalidadesArray[indice].estatus
  }
  checarFuncionalidad = (estatus, id) => {
    this.FuncionalidadesArray.push({ estatus: estatus, id: id })
  }
  checarFuncionalidadesTeam = (valor) => {
    this.checarFuncionalidades = valor;
  }
  searching = (event) => {
    this.setState({ search: event.target.value })
  }
  cleanArrayList = () => {
    this.FuncionalidadesArray = [];
  }
  changeBloque = (event) => {
    this.setState({ bloque: event });
    let funcionalidades=[];
    this.props.stor.funcionalidades_object.filter(word => word.bloque.nombre.includes( event.label )).sort().map((elemento, index) =>{
      this.state.Funcionalidades.map((elemFuncionalidad, ind) => {
        if (elemFuncionalidad.idFuncionalidad === elemento.id) {
          funcionalidades.push(elemento);
        }
      });
    });
    this.setState({ funcionalidades: funcionalidades });
  }
  render() {
    return (
      <div>
        {/**
          *   Elementos de plataformas
          */
        }
        {this.cleanArrayList()}
        {this.state.accion === "modificar" ?
          <div>
            <Grid.Row>
              <Grid.Col sm={4} lg={4}>
                <Card
                  title="Opc"
                  isCollapsible={false}
                  //isClosable
                  isCollapsed={false}
                  options={<Form.Group>
                    <span className="float-right">
                      <Form.Input
                        className="mb-3"
                        icon="search"
                        placeholder="Buscar elemento..."
                        position="append"
                        onChange={this.searching}
                      />
                    </span>
                    <div className="float-right" style={{ "width": "160px" }}>
                      <Select value={ this.state.bloque } onChange={this.changeBloque} options={ this.bloques } />
                    </div>                    
                    
                  </Form.Group>}
                  body={
                    <div>
                      <Form.Group>
                        <Table
                          cards={true}
                          striped={true}
                          responsive={true}
                          className="table-vcenter"
                        >
                          <Table.Header>
                            <Table.ColHeader>ID</Table.ColHeader>
                            <Table.ColHeader>campo</Table.ColHeader>
                            <Table.ColHeader>Nombre</Table.ColHeader>
                            <Table.ColHeader>Status</Table.ColHeader>
                          </Table.Header>
                          <Table.Body>
                            {
                              this.props.stor.funcionalidades_object
                                .filter(word => word.bloque.nombre.includes( this.state.bloque.label ) &&   
                                                word.nombre.toUpperCase().includes(this.state.search.toUpperCase())
                                                ).sort().map((elemento, index) =>
                                <Table.Row>
                                  <Table.Col>{elemento["id"]}</Table.Col>
                                  <Table.Col>{elemento["nombre"]}</Table.Col>
                                  <Table.Col>{elemento["label"]}</Table.Col>
                                  {this.checarFuncionalidadesTeam(0)}
                                  {this.idPerfilesFuncionalidades = ""}
                                  {
                                    this.state.Funcionalidades.map((elemFuncionalidad, ind) => {
                                      if (elemFuncionalidad.idFuncionalidad === elemento.id) {

                                        { this.checarFuncionalidadesTeam(1) }
                                        this.idPerfilesFuncionalidades = elemFuncionalidad.id;
                                      }
                                    })
                                  }
                                  {this.checarFuncionalidad(this.checarFuncionalidades, this.idPerfilesFuncionalidades)}
                                  <Table.Col><Form.Switch type="Checkbox" name="toggle" value="option1"
                                    checked={this.checkedFuncionalidades(index)}
                                    className={"disabled"}
                                    onChange={() => this.changeFuncionalidades(index, elemento["id"], this.checarFuncionalidades)} /></Table.Col>
                                </Table.Row>
                              )
                            }

                          </Table.Body>
                        </Table>
                      </Form.Group>
                    </div>
                  }
                />
              </Grid.Col>
              <Grid.Col>
                <Grid.Row>
                  <Grid.Col>
                    {this.state.bloque.label == "Administracion" ?      <AdminstracionView  funcionalidades={ this.state.funcionalidades } />: null}
                    {this.state.bloque.label == "Monitoreo_Naviero" ?   <MonitoreoPageView  funcionalidades={ this.state.funcionalidades }  bloque={ this.state.bloque.label } updatePanel={this.state.updatePanel } />: null}
                    {this.state.bloque.label == "Monitoreo_Terrestre" ? <MonitoreoPageView  funcionalidadesT={ this.state.funcionalidades } bloque={ this.state.bloque.label } updatePanel={this.state.updatePanel } />: null}
                    {this.state.bloque.label == "Consola_Naviera" ?     <UsuarioConsolaView funcionalidades={ this.state.funcionalidades }  bloque={ this.state.bloque.label } />: null}
                    {this.state.bloque.label == "Consola_Terrestre" ?   <UsuarioConsolaView funcionalidades={ this.state.funcionalidades }  bloque={ this.state.bloque.label } />: null}
                    {this.state.bloque.label == "Asignar_GPS" ?         <AsignarGpsView     funcionalidades={ this.state.funcionalidades }  bloque={ this.state.bloque.label } />: null}
                    {this.state.bloque.label == "Recuperar_GPS" ?       <RecuperarGpsView   funcionalidades={ this.state.funcionalidades }  bloque={ this.state.bloque.label } />: null}
                    {this.state.bloque.label == "Dashboard" ?           <DashboardView      funcionalidades={ this.state.funcionalidades }  bloque={ this.state.bloque.label } />: null}
                  </Grid.Col>
                </Grid.Row>   
              </Grid.Col>
            </Grid.Row>
          </div>
          : null}
      </div>
    )
  }
}
export default Bloques;
